<template>
  <div style="pointer-events: auto;">
    <div
      v-if="activeService"
      class="fixTop"
    >
      <v-sheet
        v-if="wsServices.alertNoFeature || wsServices.alertPeriod || wsServices.alertNoWMTSFeature"
        dark
        width="100vw"
        class="d-flex py-1 px-2 justify-center"
        color="warning"
        style="font-size: 14px;"
      >
        <span v-if="wsServices.alertNoFeature">
          <b>{{ $t('ServiceCard.errorAlert') }}</b>
        </span>
        <span v-else-if="wsServices.alertPeriod">
          Unauthorized time interval, please try again.
        </span>
        <span v-else-if="wsServices.alertNoWMTSFeature">
          {{ $t('ServiceCard.noWmtsFeaturesFound') }}
        </span>
      </v-sheet>
    </div>

    <v-sheet class="d-flex flex-column">
      <!-- Indicatore time step -->
      <v-sheet
        v-if="showInfoLabels"
        dark
        width="auto"
        style="font-size: 14px; gap: 12px"
        class="d-flex py-1 px-3 justify-space-between"
        :color="'RMprimary'"
      >
        <span><b>{{ $t(`${activeService.ws_name}:${activeService.layer_name}_serviceID:${activeService.service_id}.label`) }}</b></span>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <div
              v-show="activeService.animation_time_array"
              v-on="on"
            >
              <span v-if="!activeService.is_animation">
                {{ $t('ServiceCard.lastUpdateDate') }} <b>{{ dailyData ? animationCurrentStep.split(" ")[0] : animationCurrentStep }}</b>
              </span>
              <span v-else>
                <b>{{ dailyData ? animationCurrentStep.split(" ")[0] : animationCurrentStep }}</b>
              </span>
            </div>
          </template>
          <span>
            {{ $t('ServiceCard.localTime') }}
          </span>
        </v-tooltip>
      </v-sheet>

      <!-- Sezione slider e buttons -->
      <div
        v-if="showSlider"
        class="d-flex align-center py-2"
      >
        <v-slider
          v-model="index"
          class="mx-2"
          color="RMprimary"
          width="100%"
          track-color="#9DDAB4"
          hide-details
          :disabled="isPlaying || activeService.animation_time_array.length <= 1"
          :step="1"
          :max="activeService.animation_time_array.length - 1"
          @input="updateServiceFromSlider()"
        />
        <v-btn
          v-for="player of playerIcons"
          :key="player"
          icon
          outlined
          color="#505050"
          class="mr-2"
          :disabled="playerIconsDisabled(player) || isChangingStep"
          @click="changeAnimationStep(player)"
        >
          <v-icon dark>
            {{ player }}
          </v-icon>
        </v-btn>
      </div>

      <!-- Sezione textfield data inizio e fine -->
      <div
        v-if="$route.params.id === 'Archive' && activeService"
        class="d-flex align-center pa-2"
      >
        <v-text-field
          v-model="startTime"
          class="mr-1"
          :label="$t('ServiceCard.startDate')"
          :disabled="isPlaying"
          dense
          readonly
          outlined
          hide-details
          @click="dateRangeMenu = true"
        />
        <v-text-field
          v-model="endTime"
          :label="$t('ServiceCard.endDate')"
          :disabled="startTime === '' || isPlaying"
          class="ml-1"
          dense
          readonly
          outlined
          hide-details
          @click="dateRangeMenu = true"
        />
      </div>
    </v-sheet>

    <!-- Dialog Selezione Range Data e Ora-->
    <v-dialog
      v-model="dateRangeMenu"
      :transition="false"
      max-width="80%"
    >
      <v-card color="white">
        <v-card-text class="pa-0">
          <v-sheet
            class="pa-3"
            color="RMprimary"
            dark
            style="font-size: 16px;"
          >
            <b>{{ $t(`ServiceCard.${activeService.service_id}.title`) }}</b><br>
            {{ $t(`${activeService.ws_name}:${activeService.layer_name}_serviceID:${activeService.service_id}.label`) }}
          </v-sheet>
          <v-alert
            dense
            outlined
            color="orange"
            class="ma-2"
          >
            {{ $t('ServiceCardArchive.maxRangeDescription') }}: {{ maxRange }} {{ $t(`ServiceCardArchive.${maxRangeType}`) }}.
          </v-alert>
          <v-date-picker
            v-model="tmpDateRange"
            no-title
            scrollable
            full-width
            range
            color="RMprimary"
            :min="minRangeDate"
            :max="maxRangeDate"
            :locale="app_user.app_user_data[0].language"
            first-day-of-week="1"
          />
          <!-- Sezione orari: visibile solo se il servizio non è giornaliero -->
          <div v-if="!dailyData">
            <v-divider class="ma-2" />
            <!-- Riga 1: Data inizio + Orario inizio -->
            <div class="d-flex align-center pa-2">
              <v-text-field
                v-model="tmpDateRange[0]"
                class="mr-2"
                :label="$t('ServiceCard.startDate')"
                outlined
                dense
                hide-details
                readonly
                disabled
              />
              <v-text-field
                v-model="tmpStartTime"
                type="time"
                :label="$t('ServiceCard.startTime')"
                outlined
                dense
                hide-details
              />
            </div>
            <!-- Riga 2: Data fine + Orario fine -->
            <div class="d-flex align-center pa-2">
              <v-text-field
                v-model="tmpDateRange[1]"
                class="mr-2"
                :label="$t('ServiceCard.endDate')"
                outlined
                dense
                hide-details
                readonly
                disabled
              />
              <v-text-field
                v-model="tmpEndTime"
                type="time"
                :label="$t('ServiceCard.endTime')"
                outlined
                dense
                hide-details
              />
            </div>
          </div>
        </v-card-text>
        <v-card-actions class="justify-end pa-2 pt-4">
          <v-btn
            id="submit"
            color="#0da344"
            small
            style="color:white"
            :disabled="tmpDateRange.length < 2 || tmpDateRange[0] === '' || tmpDateRange[1] === ''"
            @click="changeDateRange()"
          >
            {{ $t('ServiceCard.confirmFilter') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { getFormattedCurrentDate } from '@/utils.js';
import { BINARY_BASE_URL } from '@/constants.js';

export default {
  props: {
    autoOpenRangeDate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isChangingStep: false,
      dateRangeMenu: false,
      index: 0,
      startDateTimeTab: 0,
      animationCurrentStep: '',
      tmpDateRange: [],
      tmpStartTime: '',
      tmpEndTime: '',
      maxEndDate: '',
      playerIcons: ['mdi-skip-previous', 'mdi-play', 'mdi-skip-next']
    };
  },
  computed: {
    ...mapState(['map', 'policy', 'app_user', 'geoserver_data', 'wsServices']),
    activeService() {
      return this.wsServices.activeServices[0];
    },
    dailyData() {
      return this.activeService ? this.activeService.daily_data : false;
    },
    maxRangeType() {
      switch (this.activeService.animation_step_date_type.split('_')[1]) {
        case 'months':
          return 'yearsRange';
        case 'days':
          return 'monthsRange';
        default:
          return 'monthRange';
      }
    },
    maxRange() {
      switch (this.maxRangeType) {
        case 'yearsRange':
          return 10;
        case 'yearRange':
          return 1;
        case 'monthsRange':
          return 3;
        default:
          return 1;
      }
    },
    startTime() {
      const date = this.tmpDateRange.length > 0 ? this.tmpDateRange[0] : '';
      const time = this.tmpStartTime ? this.tmpStartTime : '';
      const dateTime = date !== '' ? `${date} ${time}` : '';

      return this.dailyData ? date : dateTime;
    },
    endTime() {
      const date = this.tmpDateRange.length > 1 ? this.tmpDateRange[1] : '';
      const time = this.tmpEndTime ? this.tmpEndTime : '';
      const dateTime = date !== '' ? `${date} ${time}` : '';

      return this.dailyData ? date : dateTime;
    },
    showSlider() {
      return this.activeService
        && !this.wsServices.alertPeriod
        && !this.wsServices.alertNoWMTSFeature
        && this.activeService.is_animation
        && this.activeService.animation_time_array
        && this.activeService.animation_time_array.length > 0;
    },
    showInfoLabels() {
      return (
        this.activeService &&
        !this.wsServices.alertNoWMTSFeature &&
        (this.$route.params.id === 'Archive' || this.activeService.animation_time_array)
      );
    },
    isPlaying() {
      return this.activeService && this.map.isAnimating.includes(this.activeService.service_id);
    },
    minRangeDate() {
      if (this.tmpDateRange[0]) {
        if (this.tmpDateRange[1]) {
          return this.activeService.minDate;
        }

        return this.tmpDateRange[0];
      } else {
        return this.activeService.minDate;
      }
    },
    maxRangeDate() {
      if (this.tmpDateRange[0]) {
        if (this.tmpDateRange[1]) {
          return this.activeService.maxDate;
        }

        const maxDate = new Date(this.tmpDateRange[0]);

        if (this.maxRangeType.includes('year')) {
          maxDate.setFullYear(maxDate.getFullYear() + this.maxRange);
        } else {
          maxDate.setMonth(maxDate.getMonth() + this.maxRange);
        }

        if (maxDate > new Date(this.activeService.maxDate)) {
          maxDate.setTime(new Date(this.activeService.maxDate).getTime());
        }

        return maxDate.toISOString();
      } else {
        return this.activeService.maxDate;
      }
    }
  },
  watch: {
    $route() {},
    'wsServices.pauseAnimation': {
      async handler(newValue) {
        if (newValue) {
          this.map.isAnimating = this.map.isAnimating.filter(id => id !== this.activeService.service_id);
        } else {
          if (!this.isPlaying) {
            this.map.isAnimating.push(this.activeService.service_id);
            await this.runAnimationLoop();
          }
        }
      }
    },
    'wsServices.updateStep': {
      async handler(newValue) {
        if (newValue && this.activeService && Object.keys(this.activeService).length > 0) {
          this.index = this.activeService.animation_start_index;
          this.updateCurrentStep(this.index);
          this.wsServices.updateStep = false;
        }
      }
    },
    'wsServices.rangeDateTime': {
      async handler(newValue) {
        if (newValue.length == 0) {
          this.tmpDateRange = [];
          [this.tmpStartTime, this.tmpEndTime] = ['', ''];
        }
      }
    },
    autoOpenRangeDate: {
      async handler(newValue) {
        if (newValue && this.$route.params.id === 'Archive') {
          setTimeout(() => {
            this.dateRangeMenu = true;
          }, 300);
          // Reset the flag after opening the dialog
          await this.setAutoOpenRangeDate(false);
        }
      }
    },
    tmpDateRange(newRange, oldRange) {
      if (!newRange || newRange.length === 0) {
        this.tmpStartTime = '';
        this.tmpEndTime = '';

        return;
      }

      if (newRange[0] && (!oldRange || newRange[0] !== oldRange[0])) {
        this.tmpStartTime = '00:00';
      }

      if (newRange.length === 1) {
        this.tmpEndTime = '';
      }

      if (newRange.length > 1 && newRange[1] && (!oldRange || newRange[1] !== oldRange[1])) {
        this.tmpEndTime = '00:00';
      }
    }
  },
  mounted() {
    // If the flag was set before Player mounted, open dialog on mount
    if (this.autoOpenRangeDate && this.$route.params.id === 'Archive') {
      setTimeout(() => {
        this.dateRangeMenu = true;
      }, 300);
      this.setAutoOpenRangeDate(false);
    }
  },
  methods: {
    ...mapActions(['loadRasterLayer', 'updateVectorLayer', 'resetAnimationTime', 'getLayerExtent', 'setAutoOpenRangeDate']),
    playerIconsDisabled(player) {
      if (this.activeService?.animation_time_array.length <= 1) {
        return true;
      } else {
        return this.map.disableAnimationPlay && !(this.isPlaying && player === 'mdi-pause');
      }
    },
    async changeAnimationStep(player) {
      switch (player) {
        case 'mdi-skip-previous':
          this.isChangingStep = true;
          await this.prevAnimationStep();
          this.isChangingStep = false;
          break;
        case 'mdi-skip-next':
          this.isChangingStep = true;
          await this.nextAnimationStep();
          this.isChangingStep = false;
          break;
        case 'mdi-play':
          this.map.isAnimating.push(this.activeService.service_id);
          this.playerIcons[1] = 'mdi-pause';
          this.map.disableAnimationPlay = true;
          await this.runAnimationLoop();

          break;
        case 'mdi-pause':
          this.playerIcons[1] = 'mdi-play';
          this.map.disableAnimationPlay = false;
          this.map.isAnimating = this.map.isAnimating.filter(id => id !== this.activeService.service_id);
          await this.resetAnimationTime();
          break;
        default:
          break;
      }
    },
    async runAnimationLoop() {
      while (this.isPlaying && !this.wsServices.pauseAnimation) {
        await this.nextAnimationStep(); // Carica il nuovo step
        await new Promise(resolve => setTimeout(resolve, 500));
      }
    },
    async nextAnimationStep() {
      if (this.wsServices.pauseAnimation || !this.activeService?.animation_time_array?.length) {
        return;
      }

      let tempIndex = this.index + 1;

      if (tempIndex >= this.activeService?.animation_time_array.length) {
        tempIndex = 0;
      }

      await this.loadLayer(tempIndex);
      await this.updateCurrentStep(tempIndex);
      this.index = tempIndex;
    },
    async prevAnimationStep() {
      let tempIndex = this.index - 1;

      if (tempIndex < 0) {
        tempIndex = this.activeService.animation_time_array.length - 1;
      }

      await this.loadLayer(tempIndex);
      await this.updateCurrentStep(tempIndex);
      this.index = tempIndex;
    },
    async updateCurrentStep(index) {
      if (!this.activeService?.animation_time_array) {
        return;
      }

      const step = this.activeService?.animation_time_array[index];

      if (step) {
        const vectorIndex = this.$route.params.id === 'Forecast' ? 0 : 1;
        const date = this.activeService.service_type === 'RASTER'
          ? new Date(step)
          : new Date(step?.split('/')[vectorIndex]);

        this.animationCurrentStep = getFormattedCurrentDate(date);
      }

      this.wsServices.alertNoFeature = this.activeService.animation_empty_steps?.includes(step);
    },
    async updateServiceFromSlider() {
      this.activeService.animation_start_index = this.index;
      this.updateCurrentStep(this.index);
      this.loadLayer(this.index);
    },
    async loadLayer(index) {
      if (this.activeService?.service_type === 'RASTER') {
        const extent = await this.getLayerExtent([this.activeService.ws_name, this.activeService.layer_name, this.activeService.layer_type, this.activeService.service_id]);
        const step = this.activeService?.animation_time_array[index];
        const noData = this.activeService?.animation_empty_steps?.includes(step);

        const rasterParams = {
          url: `${BINARY_BASE_URL}/fe_ogc/geoserver/wms`,
          params: {
            ENV: '',
            GROUP: this.$route.params.id,
            LAYERS: `${this.activeService.ws_name}:${this.activeService.layer_name}`,
            TIME: this.activeService.animation_time_array[index],
            STYLES: this.activeService.layer_style,
            USERNAME: this.app_user.username,
            SERVICE_NAME: this.activeService.service_name,
            FORMAT: 'image/vnd.jpeg-png8'
          },
          NO_DATA: noData,
          TYPE: 'RASTER',
          LAYER_SERVICE_ID: this.activeService.service_id,
          UDM: this.activeService.udm,
          UDM_CONVERSIONS: this.activeService.udm_conversions,
          IS_MULTI_VARIABLE: this.activeService.is_multi_variable,
          MULTI_VARIABLE_LAYERS: this.activeService.multi_variable_layers || [],
          MULTI_VARIABLE_LAYER_CONFIGS: this.activeService.multi_variable_layer_configs || [],
          EXTENT: extent
        };

        await this.loadRasterLayer(rasterParams);
      } else {
        await this.openVectorLayer(index);
      }
    },
    async openVectorLayer(index) {
      //this.map.sliderOpacityValue = this.selectedVectorLayer.layer_opacity;

      const vectorParams = {
        params: {
          GROUP: this.$route.params.id,
          LAYERS: `${this.activeService.ws_name}:${this.activeService.layer_name}`,
          TIME: this.activeService.animation_time_array[index],
          STYLES: this.activeService.layer_style,
          USERNAME: this.app_user.username,
          SERVICE_NAME: this.activeService.service_name,
          PARAM_RANGE: this.map.vectorParamRange[this.activeService.service_id]
        },
        TYPE: 'VECTOR',
        LAYER_SERVICE_ID: this.activeService.service_id,
        UDM: this.activeService.udm,
        UDM_CONVERSIONS: this.activeService.udm_conversions,
        EXTENT: this.geoserver_data.geographicDomains[this.activeService.service_id],
        AGGREGATION_INTERVAL: this.activeService.aggregation_interval ?? null
      };

      const layerFound = this.map.OLmap.getLayers().getArray().slice(1).some(selectedLayer => selectedLayer.values_.time === vectorParams.params.TIME && (selectedLayer.values_.layer_name === vectorParams.params.LAYERS && selectedLayer.values_.service_id === vectorParams.LAYER_SERVICE_ID));

      if (!layerFound) {
        await this.updateVectorLayer(vectorParams);
      }
    },
    calculateMaxEndDate() {
      if (!this.dailyData) {
        // compute candidate time as now or capped to maxStep if maxStep is earlier
        const stepType = this.activeService.animation_step_date_type.split('_')[0];
        const maxStepDateTime = new Date(this.activeService.maxDate);
        let candidate = new Date();

        if (stepType !== 'dynamic' && (maxStepDateTime < new Date())) {
          candidate = maxStepDateTime;
        }

        // determine unit and step in minutes
        const stepUnit = this.activeService.animation_step_date_type.split('_')[1];
        const stepValue = parseInt(this.activeService.animation_step, 10) || 1;
        const stepMinutes = stepUnit === 'hours' ? stepValue * 60 : stepValue;

        // total minutes since midnight for candidate
        const totalMinutes = candidate.getHours() * 60 + candidate.getMinutes();
        const roundedTotal = Math.floor(totalMinutes / stepMinutes) * stepMinutes;

        // build rounded date
        const roundedDate = new Date(candidate.getTime());
        roundedDate.setHours(Math.floor(roundedTotal / 60));
        roundedDate.setMinutes(roundedTotal % 60);
        roundedDate.setSeconds(0, 0);

        const date = roundedDate.toISOString().split('T')[0];
        const hours = String(roundedDate.getHours()).padStart(2, '0');
        const minutes = String(roundedDate.getMinutes()).padStart(2, '0');
        this.maxEndDate = `${date} ${hours}:${minutes}`;
      }
    },
    async changeDateRange() {
      this.dateRangeMenu = false;

      if (this.tmpDateRange.length === 2 && this.tmpDateRange[0] && this.tmpDateRange[1]) {
        // Validazione: verificare che la data fine non superi il massimo range consentito
        this.calculateMaxEndDate();

        if (new Date(this.tmpDateRange[1] + ' ' + this.tmpEndTime) > new Date(this.maxEndDate)) {
          this.tmpDateRange[1] = this.maxEndDate.split(' ')[0];
          this.tmpEndTime = this.maxEndDate.split(' ')[1];
        }

        this.wsServices.rangeDateTime = [new Date(this.startTime), new Date(this.endTime)];
      }
    }
  }
};
</script>

<style scoped>
.RMprimary-color {
  color: #00A644;
}
@media (min-device-width:280px) and (max-device-width:767px){
  .mobile-margin {
   padding-left: 12px !important;
  }
}
.fixTop {
  position: fixed;
  font-size: 16px;
  top: 0px;
  width: 100vw;
}
</style>
